export default __webpack_public_path__ + "static/media/sp_Icon.a64327d3.svg";